import React from 'react'
import { Dropdown, DropdownProps, Popup } from 'semantic-ui-react'
import isFunction from 'lodash/fp/isFunction'

type RenderProp = (ref: React.Ref<any>) => JSX.Element

interface IPopupDropdownProps extends Pick<DropdownProps, 'options'> {
  trigger: JSX.Element | RenderProp
  scaleWithTrigger?: boolean
  onChange?: (value: any) => void
}

interface IPopupDropdownState {
  open: boolean
}

export class PopupDropdown extends React.PureComponent<IPopupDropdownProps, IPopupDropdownState> {
  state = {
    open: false
  }

  private trigger = React.createRef<React.ComponentType>()

  onPopupOpen = () => {
    this.forceUpdate()

    this.setState(() => ({
      open: true
    }))
  }

  onPopupClose = () => {
    this.setState(() => ({
      open: false
    }))
  }

  onItemSelect = (value: string | number | boolean) => {
    const { onChange } = this.props

    if (onChange) {
      onChange(value)
    }

    this.setState(() => ({
      open: false
    }))
  }

  render() {
    const { children, trigger, onChange, options, scaleWithTrigger, ...rest } = this.props

    const width =
      this.trigger.current instanceof Dropdown
        ? // cast to any because ref is available on the referenced component at
          // runtime to set the dropdown's width but the types aren't
          // correct here not sure what the correct type would be for this.
          (this.trigger.current as any).ref.clientWidth
        : 150

    return (
      <Popup
        basic
        on='click'
        position='bottom left'
        style={{ width }}
        trigger={isFunction(trigger) ? trigger(this.trigger) : trigger}
        wide='very'
        className='popup-dropdown'
        open={this.state.open}
        onOpen={this.onPopupOpen}
        onClose={this.onPopupClose}
        {...rest}
      >
        {children || (
          <div className='menu-container'>
            <Dropdown.Menu>
              {options &&
                options.map(option => (
                  <Dropdown.Item key={option.value!.toString()} {...option} onClick={() => this.onItemSelect(option.value!)} />
                ))}
            </Dropdown.Menu>
          </div>
        )}
      </Popup>
    )
  }
}
